import { apiV2 } from './api';

/**
 * Admin-Setting „BK und PB per E-Mail benachrichtigen" (Einstellungen →
 * E-Mail-Vorlagen): welche E-Mail-Vorlage beim Anlegen einer Betreuung mit
 * gesetzter Checkbox an die BK bzw. an die PB geht. `null` = keine Vorlage —
 * dann bleibt es bei der bisherigen Standard-Nachricht.
 * Gespeichert in `GET/PUT /v2/admin/system-settings`; PUT schickt nur den
 * geänderten Key (Backend validiert mit 'sometimes').
 */
export interface CareNotifyTemplates {
  bk: number | null;
  pb: number | null;
}

type Raw = { care_notify_bk_template_id?: number | null; care_notify_pb_template_id?: number | null };

const fromRaw = (d: Raw): CareNotifyTemplates => ({
  bk: d.care_notify_bk_template_id ?? null,
  pb: d.care_notify_pb_template_id ?? null,
});

export const careNotifyTemplatesApi = {
  get: async (): Promise<CareNotifyTemplates> => {
    const res = await apiV2.get<{ data: Raw }>('/admin/system-settings');
    return fromRaw(res.data.data ?? {});
  },

  update: async (side: 'bk' | 'pb', templateId: number | null): Promise<CareNotifyTemplates> => {
    const res = await apiV2.put<{ data: Raw }>('/admin/system-settings', {
      [side === 'bk' ? 'care_notify_bk_template_id' : 'care_notify_pb_template_id']: templateId,
    });
    return fromRaw(res.data.data ?? {});
  },
};
